
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, watch, reactive, onMounted, defineComponent} from 'vue';
import {useTicketStore} from '../../stores/TicketStore';
import {storeToRefs} from 'pinia'
import LoadingSpinner from "../../components/loading/LoadingSpinner.vue";
import {throwAlertMessage} from "../../utils/utils";

export default defineComponent({
    name: 'SuccessView',
    components: {
        LoadingSpinner,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        ticketId: {
            type: String,
            required: true,
        },
        stepViews: {
            type: Array,
            required: true
        },
        successData: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },
    setup(props) {
        const ticketStore = useTicketStore();
        const {
            step,
        } = storeToRefs(ticketStore);

        const _config = window._config || {};
        const baseUrl = _config.successUrls;

        if (!baseUrl) {
            throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.successUrls". Value of "_config.successUrls" was not set in _config', true);
        }

        const continueUrl = baseUrl.continueShopping;
        const cartUrl = baseUrl.cart;
        const checkoutUrl = baseUrl.checkout;

        function clickCheckoutButton () {
            window.dataLayer.push({
                'event': 'click_checkout',
                'type': 'ticket_configurator'
            })
        }


        return {
            step,
            continueUrl,
            cartUrl,
            checkoutUrl,
            translate,
            clickCheckoutButton,
        };
    }
});

if (typeof _trackingData !== 'undefined' && typeof _trackingData['click-checkout'] === 'undefined') {
    _trackingData['click-checkout'] = {
        'trigger': 'click',
        'datalayer': {
            'event': 'click_checkout',
            'type': 'ticket_configurator',
        }
    }
}
